import { axios } from '@Root/API'

export const remove = payload => {
	return axios.delete(`student-engagement/${payload}`)
}
